import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { SeveridadeToast } from '../../models/enums/severidade-toast.enum';
import { AuthService } from '../../services/auth.service';
import { ToastService } from '../../services/toast.service';
import { SpinnerService } from '../../services/spinner.service';

@Component({
  selector: 'app-sign-up-email',
  templateUrl: './sign-up-email.component.html',
  styleUrls: ['./sign-up-email.component.scss']
})
export class SignUpEmailComponent implements OnInit {

  id!: number;
  submitted = false;
  selectAllChecked = false;

  formLogin = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email])
  });

  constructor(
    private router: Router,
    private authService: AuthService,
    private toastService: ToastService,
    private spinnerService: SpinnerService
  ) { }

  ngOnInit(): void { }

  get form(): any { return this.formLogin.controls; }

  onSubmit() {
    this.submitted = true;

    if (this.formLogin.invalid) {
      return;
    }
    this.validateEmail();
  }

  validateEmail() {
    const email = this.formLogin.value.email ?? '';
    this.spinnerService.show();
    this.authService.signupEmail(email).subscribe({
      next: (response) => {
        if (response?.userExists === false) {
          this.router.navigate(['/sign-up'], { queryParams: { email: response.email ?? email } });
        } else if (response?.userExists === true) {
          if (response.verificationToken || response.token) {
            localStorage.setItem('token', response.verificationToken ?? response.token);
          }
          this.toastService.setMensagemToast(
            'Enviamos um e-mail de validação da aquisição deste novo produto, favor confirmar no e-mail e realizar o login.',
            SeveridadeToast.Success
          );
        }
        this.spinnerService.hide();
      },
      error: (error) => {
        if (error?.userExists === false || error?.status === 404) {
          this.router.navigate(['/sign-up'], { queryParams: { email } });
          this.spinnerService.hide();
          return;
        }
        this.toastService.setMensagemToast('Erro ao enviar email de validação.', SeveridadeToast.Error);
        this.spinnerService.hide();
      }
    });
  }

  redirectTo(route: string) {
    this.router.navigateByUrl(route);
  }
}
